import { ThemedFunctor } from '@doveit/bricks';
import { css } from 'styled-components';

export const popoverTrigger: ThemedFunctor = () => css`
  cursor: pointer;
`;

export const warningIcon: ThemedFunctor = ({ theme }) => css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${theme.remSize[250]};
  height: ${theme.remSize[250]};
  border-radius: ${theme.remSize[250]};
  background-color: ${theme.color.background.warning.default.high};
  color: ${theme.color.foreground.warning.default.low};
`;

export const popoverContent: ThemedFunctor = ({ theme }) => css`
  padding: ${theme.remSize[100]};
  max-height: 300px;
  overflow-y: auto;
  width: 350px;
`;

export const mobileFooter: ThemedFunctor = ({ theme }) => css`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: ${theme.remSize[150]};
`;

export const mobileFooterSummary: ThemedFunctor = ({ theme }) => css`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.remSize[150]};
  min-height: ${theme.remSize[300]};
`;

export const mobileFooterActions: ThemedFunctor = ({ theme }) => css`
  display: flex;
  gap: ${theme.remSize[150]};

  & > * {
    flex: 1;
  }
`;
